import { useAtomCallback } from 'jotai/utils';

import type { Organization } from '../types';
import { useUpsert } from './useUpsert';

export function useMeOrgResponse() {
  const { upsert } = useUpsert();
  const setMeOrgFromResponse = useAtomCallback<void, [Organization]>((_, __, me) => {
    upsert(me);
  });

  return { setMeOrgFromResponse };
}
